import { render, staticRenderFns } from "./ColInfoDialog.vue?vue&type=template&id=f1e584e8&scoped=true"
import script from "./ColInfoDialog.vue?vue&type=script&lang=js"
export * from "./ColInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e584e8",
  null
  
)

export default component.exports